import { api } from "./paths";
import axios from "axios";

export async function userLogout() {
  return await axios.post(api.LOGOUT_URL);
}
